{
  "version": 1,
  "asset_id": "8f4ba00b-d8b3-4282-9965-180a28ea7961",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8f4ba00b-d8b3-4282-9965-180a28ea7961/bypass-revision-resection-en-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8f4ba00b-d8b3-4282-9965-180a28ea7961/bypass-revision-resection-en-800.webp",
  "original_filename": "bypass-revision-resection-en-800.webp",
  "size": 82136,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:41:28Z"
}
